// Legal page content (Privacy Policy & Terms of Use)

export const PRIVACY = {
  title: "Privacy Policy",
  updated: "Last updated: February 1, 2026",
  intro:
    "Medhive, Inc. (\"MedHive\", \"we\", \"us\") respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains what information we collect through medhive.ai and our platform, how we use it, and the choices you have.",
  sections: [
    {
      h: "1. Information We Collect",
      p: [
        "Information you provide directly: when you fill out our contact or demo request forms we collect your name, work email address, company name, and the contents of your message.",
        "Usage information: we may collect standard technical data such as browser type, device information, pages visited, and approximate location derived from your IP address to understand how our website is used.",
        "Platform data: when customers use the MedHive platform, we process the data they upload solely on their behalf and under the terms of the applicable customer agreement and Data Processing Addendum.",
      ],
    },
    {
      h: "2. How We Use Your Information",
      p: [
        "To respond to your inquiries and schedule product demonstrations.",
        "To provide, operate, secure, and improve our website and platform.",
        "To send communications you have requested; you can opt out at any time.",
        "To comply with legal obligations and enforce our agreements.",
      ],
    },
    {
      h: "3. How We Share Information",
      p: [
        "We do not sell your personal information. We share it only with trusted service providers who help us operate our business (such as cloud hosting and scheduling tools), under contractual confidentiality obligations, or where required by law.",
      ],
    },
    {
      h: "4. Data Security",
      p: [
        "MedHive applies industry-standard safeguards, including encryption of data in transit and at rest, role-based access controls, and continuous monitoring. Our security program is aligned with SOC 2 and ISO 27001 requirements.",
      ],
    },
    {
      h: "5. Data Retention",
      p: [
        "We retain personal information only for as long as necessary to fulfill the purposes described in this policy, or as required by law. You may request deletion of your information at any time.",
      ],
    },
    {
      h: "6. Your Rights",
      p: [
        "Depending on your location, you may have rights under the GDPR, CCPA/CPRA, or similar laws, including the right to access, correct, delete, or port your personal information, and the right to object to or restrict certain processing. To exercise these rights, contact us at contact.us@medhive.ai.",
      ],
    },
    {
      h: "7. Cookies",
      p: [
        "Our website uses essential cookies for functionality and may use analytics cookies to improve our services. You can control cookies through your browser settings.",
      ],
    },
    {
      h: "8. International Transfers",
      p: [
        "If information is transferred outside your jurisdiction, we use appropriate safeguards such as standard contractual clauses.",
      ],
    },
    {
      h: "9. Children's Privacy",
      p: [
        "Our services are intended for business use and are not directed to children under 16. We do not knowingly collect information from children.",
      ],
    },
    {
      h: "10. Changes to This Policy",
      p: [
        "We may update this Privacy Policy from time to time. Material changes will be posted on this page with an updated date.",
      ],
    },
    {
      h: "11. Contact Us",
      p: [
        "Medhive, Inc. — Atlanta, GA 30307. Email: contact.us@medhive.ai",
      ],
    },
  ],
};

export const TERMS = {
  title: "Terms of Use",
  updated: "Last updated: February 1, 2026",
  intro:
    "These Terms of Use (\"Terms\") govern your access to and use of the medhive.ai website and related content provided by Medhive, Inc. (\"MedHive\"). By using our website, you agree to these Terms. Use of the MedHive platform itself is governed by a separate customer agreement.",
  sections: [
    {
      h: "1. Use of the Website",
      p: [
        "You may use this website for lawful, business purposes only. You agree not to misuse the website, interfere with its operation, attempt to gain unauthorized access to any systems, or use automated means to scrape content without permission.",
      ],
    },
    {
      h: "2. No Medical Advice",
      p: [
        "MedHive is a technology company. Nothing on this website constitutes medical advice, diagnosis, or treatment. Content is provided for informational purposes about our software platform only.",
      ],
    },
    {
      h: "3. Intellectual Property",
      p: [
        "All content on this website — including text, graphics, logos, and software — is the property of Medhive, Inc. or its licensors and is protected by intellectual property laws. You may not reproduce, modify, or distribute any content without our prior written consent.",
      ],
    },
    {
      h: "4. Third-Party Links",
      p: [
        "Our website may contain links to third-party sites (for example, scheduling or social media services). We are not responsible for the content or privacy practices of those sites.",
      ],
    },
    {
      h: "5. Disclaimer of Warranties",
      p: [
        "The website is provided \"as is\" and \"as available\" without warranties of any kind, express or implied, including merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that the website will be uninterrupted or error-free.",
      ],
    },
    {
      h: "6. Limitation of Liability",
      p: [
        "To the maximum extent permitted by law, Medhive, Inc. shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of this website.",
      ],
    },
    {
      h: "7. Indemnification",
      p: [
        "You agree to indemnify and hold harmless Medhive, Inc. and its officers, employees, and agents from any claims arising out of your misuse of the website or violation of these Terms.",
      ],
    },
    {
      h: "8. Governing Law",
      p: [
        "These Terms are governed by the laws of the State of Delaware, without regard to its conflict of law principles.",
      ],
    },
    {
      h: "9. Changes to These Terms",
      p: [
        "We may revise these Terms from time to time. Continued use of the website after changes are posted constitutes acceptance of the revised Terms.",
      ],
    },
    {
      h: "10. Contact",
      p: [
        "Questions about these Terms? Email us at contact.us@medhive.ai.",
      ],
    },
  ],
};
